import constants from '../constants'
import _ from 'lodash';

export const updateDoorPreview = (state) => {
  let payload = buildPayload(state);
  return ({
    type: constants.ACTIONS.UPDATE_DOOR_PREVIEW,
    payload: payload
  });
};

const partGroups = ['DoorKnob', 'Latch', 'LockCommon', 'LockAdditional', 'LockPadCommon', 'LockPadAdditional',
  'InsideColor', 'OutsideColor', 'ForgedFinish', 'InsidePanel'];

const buildPayload = (state) => {
  let
    {constructionsState, doorPreviewState, orderState} = state,
    totalPrice = 0,
    payload = {},
    options =[],
    preview_layers = [],
    amount = 0,
    basePrice = _.get(constructionsState, 'selected_type.price') || 0;

  payload.base_price = basePrice;
  //preview_layers.push(_.get(constructionsState, 'selected_type.layer.url'));
  if (orderState.groups.size.selected == constants.GROUP_TYPES.SIZE.CUSTOM_SIZE) {
    let
      inputs =  _.get(orderState, 'groups.size.inputValues', []),
      size1_amount = _.get(orderState, 'groups.size.items[0].amount') || 0,
      size2_amount = _.get(orderState, 'groups.size.items[1].amount') || 0,
      price_2 = _.get(constructionsState, 'selected_type.price_2') || 0;

    payload.base_price = (price_2 ? price_2 : basePrice);

    amount = size1_amount + size2_amount;
    payload.comment = amount > 0 ? `Индивидуальный размер, +${amount}%` : '';
    if (inputs.length == 2) {
      options.push(buildOption(`Размер`, `${inputs[1]}x${inputs[0]}`, 0));
    }
  } else {
    payload.comment = '';
    let val = _.get(orderState, 'groups.size.items[0].value');
    val && options.push(buildOption(`Размер`, val, 0));
  }
  options.push(buildOption(`Базовая цена`, payload.base_price, 2));

  totalPrice += payload.base_price;

  if (orderState.groups.open.item) {
    options.push(buildOption(`${orderState.groups.open.title}`, orderState.groups.open.item.title, 1));
  }

  orderState.groups.parts.forEach((item) => {
    totalPrice += item.price;
    options.push(buildOption(item.title, item.price, item.orderIndex));
    if (item.layer) {
      preview_layers.push(item.layer.url);
    }
  });

  partGroups.forEach(group => {
    let item = orderState.groups[group];
    if (item) {
      totalPrice += item.price;
      options.push(buildOption(constants.PART_TITLES[group], item.price, item.orderIndex));
      if (item.layer) {
        preview_layers.push({url: item.layer.url, index: constants.PART_INDEXES[group]});
      }
    }
  });

  payload.options = _.orderBy(options, 'position');

  if (amount > 0) {
    totalPrice = totalPrice + ((totalPrice / 100) * amount)
  }

  payload.total_price = totalPrice;
  payload.preview_layers = preview_layers;

  return payload;
};

const buildOption = (title, value, position) => {
  return {string: title, value: value, position: position};
};



// WEBPACK FOOTER //
// ./app/javascript/app/actions/door_preview.js